export enum EDeliveryStateSource {    
    Portal,
    Erp,
    Mobile
}